module.exports = __webpack_public_path__ + "static/media/empire.227c7605.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/empire.jpg
 ** module id = 428
 ** module chunks = 0
 **/